import { create } from 'zustand';

export type Screen = 'overview' | 'people' | 'studios' | 'machines' | 'packages' | 'deploys' | 'logs' | 'posture';
const SCREENS: Screen[] = ['overview', 'people', 'studios', 'machines', 'packages', 'deploys', 'logs', 'posture'];

interface UiState {
  screen: Screen;
  go: (s: Screen) => void;
  /** the item open in each list screen's right panel (an id), kept across screen switches */
  selection: Partial<Record<Screen, string | null>>;
  select: (screen: Screen, id: string | null) => void;
}

function initial(): Screen {
  try { const v = localStorage.getItem('pd-screen'); if (v && (SCREENS as string[]).includes(v)) return v as Screen; } catch { /* ignore */ }
  return 'overview';
}

export const useUi = create<UiState>((set) => ({
  screen: initial(),
  go: (screen) => { try { localStorage.setItem('pd-screen', screen); } catch { /* ignore */ } set({ screen }); },
  selection: {},
  select: (screen, id) => set((s) => ({ selection: { ...s.selection, [screen]: id } })),
}));

/** The selection for one screen, as a tuple the screens can use like useState. */
export function useSelection(screen: Screen): [string | null, (id: string | null) => void] {
  const id = useUi((s) => s.selection[screen] ?? null);
  const select = useUi((s) => s.select);
  return [id, (next) => select(screen, next === id ? null : next)];
}
